import { motion } from 'framer-motion';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      icon: 'ri-search-line',
      title: 'İhtiyaç Analizi',
      description: 'İlk görüşmede ihtiyaçlarınızı, beklentilerinizi ve hedeflerinizi detaylı şekilde dinliyor ve analiz ediyoruz.',
    },
    {
      number: '02',
      icon: 'ri-calendar-check-line',
      title: 'Seans Planı',
      description: 'Size özel bir çalışma planı oluşturuyor, seans sayısı ve içeriğini birlikte belirliyoruz.',
    },
    {
      number: '03',
      icon: 'ri-heart-pulse-line',
      title: 'Uygulama & Şifa',
      description: 'Belirlenen plan doğrultusunda danışmanlık, şifa ve enerji çalışmalarınızı gerçekleştiriyoruz.',
    },
    {
      number: '04',
      icon: 'ri-line-chart-line',
      title: 'Takip & Destek',
      description: 'Süreç sonrası gelişiminizi takip ediyor, ihtiyaç duyduğunuzda destek ve rehberlik sağlıyoruz.',
    },
  ];

  return (
    <section className="py-24 bg-cream">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2 className="font-serif text-5xl font-bold text-primary-dark mb-4">
            Nasıl Çalışıyoruz?
          </h2>
          <div className="w-16 h-0.5 bg-gold"></div>
        </motion.div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-500 group"
            >
              {/* Large Number Background */}
              <div className="absolute top-8 left-8 text-[120px] font-bold text-gold/10 leading-none select-none">
                {step.number}
              </div>

              {/* Content */}
              <div className="relative z-10">
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-gold group-hover:scale-110 transition-all duration-300">
                  <i className={`${step.icon} text-2xl text-gold group-hover:text-primary-dark`}></i>
                </div>

                <h3 className="font-serif text-2xl font-bold text-primary-dark mb-4">
                  {step.title}
                </h3>

                <p className="text-text-medium leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Connector Line (Desktop Only) */}
              {index < steps.length - 1 && index % 2 === 0 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-px border-t-2 border-dashed border-gold/30"></div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;